import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';

export default function useManageRoleUser() {
  const addUser = async (
    organizationId: string,
    userId: string,
    roleId: string,
    callback?: (guid: string) => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexid/admin-role/v1/organizations/${organizationId}/roles/${roleId}/users/${userId}`;
    await fetcher({
      method: 'post',
      url,
      body: {},
    })
      .then((respData) => {
        if (callback) callback(respData.id);
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  const removeUser = async (
    organizationId: string,
    userId: string,
    roleId: string,
    callback?: (guid: string) => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    const url = `${baseApiUrl()}/lexid/admin-role/v1/organizations/${organizationId}/roles/${roleId}/users/${userId}`;
    await fetcher({
      method: 'delete',
      url,
      body: {},
    })
      .then(() => {
        if (callback) callback(userId);
      })
      .catch((err) => {
        if (onError) handleError(err, { onError });
      });
  };

  return {
    addUser,
    removeUser,
  };
}
